import axiosInstance from '@/shared/api/axios';
import type { ApiReportCreateBody, ServiceReport } from '@/shared/types/api/reports';

export const apiReportCreate = async (body: ApiReportCreateBody): Promise<ServiceReport> => {
  const { data } = await axiosInstance.post<ServiceReport>('/reports', body);
  return data;
};
